<template>
    <div id="result-table-container" class="table-container relative">
        <div class="p-4">
            <table class="result-table" border="0" cellspacing="0" cellpadding="0">
                <tr>
                    <td colspan="2" class="first-col">
                        <div class="w-full font-bold text-left pl-2">Titel der Spalte</div>
                    </td>
                    <td colspan="2" class="border-l colspan-2">
                        <div class="w-full font-bold text-center">
                            Referenz
                        </div>
                        <div v-if="resultData.variants" class="mb-2">
                            <div class="h-10 flex items-center text-center justify-center">
                                {{ resultData.variants[0].name }}
                            </div>
                        </div>
                    </td>
                    <td colspan="2" class="border-l colspan-2">
                        <div class="w-full font-bold text-center">Variante</div>
                        <div class="w-full">
                            <div class="relative px-12 mb-2">
                                <div class="w-10 h-10 absolute top-0 left-0 p-2 text-center cursor-pointer" v-if="showVariantNavigation" :class="[variantButtonClass('prev')]" @click="changeVariant('prev')">
                                    <Icon name="chevron-left"/>
                                </div>
                                <template v-for="(variant, variantIndex) in resultData.variants">
                                    <div v-if="variantIndex != 0" colspan="2" :class="variantColClass(variantIndex)">
                                        <div class="h-10 flex items-center text-center justify-center key-test">
                                            {{ variant.name }}
                                        </div>
                                    </div>
                                </template>
                                <div class="w-10 h-10 absolute top-0 right-0 p-2 text-center cursor-pointer" v-if="showVariantNavigation" :class="[variantButtonClass('next')]" @click="changeVariant('next')">
                                    <Icon name="chevron-right"/>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <template v-for="(sectionData, sectionsKey) in resultData.sections">
            <div :id="'section-' + sectionsKey" class="table-section-wrapper" :class="['section',activeSection == sectionsKey ? 'active-section' :'']">
                <div class="table-wrapper section-header relative z-20">
                    <table class="result-table" border="0" cellspacing="0" cellpadding="0">
                        <tr class="section-main-header">
                            <td colspan="2" class="first-col">
                                <div class="result-table-cell text-center justify-start font-bold" @click="toggleTableContent(sectionsKey)">
                                    <Icon :name="sectionsKey" class="text-primary-default mr-2" :height="8" :width="8"/>
                                    <div>{{ $t('result.' + sectionsKey) }}</div>
                                </div>
                            </td>
                            <template v-for="(header, headerIndex) in sectionData.headers">
                                <td colspan="2" class="border-l colspan-2" :class="variantColClass(headerIndex)">
                                    <div class="result-table-cell lining-nums tabular-nums text-center justify-center font-bold" @click="toggleTableContent(sectionsKey)">
                                        {{ formatValue(header, 'header_' + sectionsKey, sectionData.unit) }}

                                    </div>
                                </td>
                            </template>
                        </tr>
                    </table>
                    <div class="w-10 h-10 absolute right-2 top-5 p-1 cursor-pointer" @click="toggleTableContent(sectionsKey)">
                        <Icon :name="'chevron-' + (sectionsKey == activeSection ? 'up' : 'down')" :height="8" :width="8"/>
                    </div>
                </div>
                <div class="table-wrapper section-result relative z-10 pb-2">
                    <div class="overflow-hidden pb-4">
                        <table class="result-table -mb-6" border="0" cellspacing="0" cellpadding="0" :class="['section-' + sectionsKey,'section',activeSection == sectionsKey ? 'active-section' :'']">
                            <thead>
                            <tr>
                                <td colspan="2" rowspan="2" class="first-col"></td>
                                <td v-for="(variant, variantIndex) in resultData.variants" colspan="2" :class="variantColClass(variantIndex)">
                                    <div class="result-table-cell text-center justify-center font-bold relative px-12">

                                        <div class="w-10 h-10 absolute top-1/2 -mt-5 left-0 p-2 text-center cursor-pointer" v-if="showVariantNavigation && variantIndex != 0" :class="[variantButtonClass('prev')]" @click="changeVariant('prev')">
                                            <Icon name="chevron-left"/>
                                        </div>
                                        {{ variant.name }}
                                        <div class="w-10 h-10 absolute top-1/2 -mt-5 right-0 p-2 text-center cursor-pointer" v-if="showVariantNavigation && variantIndex != 0" :class="[variantButtonClass('next')]" @click="changeVariant('next')">
                                            <Icon name="chevron-right"/>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <template v-for="(variant, variantIndex) in resultData.variants">
                                    <td class="border-r" :class="[variantIndex < 1 ? '' : ' ',variantColClass(variantIndex)]">
                                        <div class="result-table-cell text-center justify-center font-bold">
                                            Heizung
                                        </div>
                                    </td>
                                    <td :class="variantColClass(variantIndex)">
                                        <div class="result-table-cell text-center justify-center font-bold">
                                            TWE
                                        </div>
                                    </td>
                                </template>
                            </tr>
                            </thead>
                            <tbody>
                            <template v-for="(rowData, rowKey) in sectionData.rows">
                                <tr :data-row="rowData.slug">
                                    <template v-if="!rowData.hidden">
                                        <template v-if="showGroupTd(rowData,rowKey,sectionData.rows)">
                                            <td :rowspan="getGroupRowspan(rowData,sectionData.rows)" class="group-col-a border-b">
                                                <div class="result-table-cell result-table-title">
                                                    {{ $t('result.' + rowData.group) }}
                                                </div>
                                            </td>
                                            <td class="group-col-b border-b">
                                                <div class="result-table-cell result-table-title">
                                                    {{ $t('result.' + rowData.slug) }}
                                                </div>
                                            </td>
                                        </template>
                                        <template v-else-if="rowData.group">
                                            <td class="group-col-b border-b">
                                                <div class="result-table-cell result-table-title">
                                                    {{ $t('result.' + rowData.slug) }}
                                                </div>
                                            </td>
                                        </template>
                                        <template v-else>
                                            <td  class="first-col border-b" colspan="2">
                                                <div class="result-table-cell result-table-title">
                                                    {{ $t('result.' + rowData.slug) }}
                                                </div>
                                            </td>
                                        </template>
                                        <template v-for="(cellData, cellDataIndex) in rowData.cells">
                                            <td v-for="(cell, cellIndex) in cellData" :colspan="cellData.length == 1 ? 2 : 1" class="border-b text-center" :class="variantColClass(cellDataIndex)">
                                                <div class="result-table-cell result-table-number lining-nums tabular-nums">
                                                    {{ formatValue(cell, rowData.slug, rowData.unit) }}

                                                </div>
                                            </td>
                                        </template>
                                    </template>
                                </tr>
                            </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import {computed, getCurrentInstance, reactive, ref, nextTick} from "vue";

export default {
    props: {
        resultData: {
            type: Object,
            required: false,
            default: {}
        }
    },
    setup(props) {

        const activeVariant = ref(1);

        const internalInstance = getCurrentInstance();
        const accounting = internalInstance.appContext.config.globalProperties.$accounting;
        const resultData = props.resultData;
        const activeSection = ref(-1);


        const showVariantNavigation = computed(() => {

            if (resultData.variants) {

                return resultData.variants.length > 2 ? true : false;
            }

            return false;
        })

        const showGroupTd = (rowData, rowKey, rowsData) => {

            const currentGroup = rowData.group;

            if (currentGroup) {
                return rowsData.filter(item => item.group === currentGroup)[0].slug == rowData.slug
            }

            return false;
        }

        const getGroupRowspan = (rowData, rowsData) => {

            const currentGroup = rowData.group;

            return rowsData.filter(item => item.group === currentGroup).length;
        }

        const toggleTableContent = async (sectionsKey) => {
            activeSection.value == sectionsKey ? activeSection.value = -1 : activeSection.value = sectionsKey;
            await nextTick();
            if(activeSection.value != -1){
                scrollTo({
                    top: getOffset(document.getElementById('section-'+activeSection.value)).top - 110,
                    left: 0
                });
            }
        }

        const getOffset = (el) => {
            var rect = el.getBoundingClientRect(),
                scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
                scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            return {top: rect.top + scrollTop, left: rect.left + scrollLeft}
        }

        const formatValue = (value, row, unit) => {

            if (value == '-') return value;
            if (['arbeitspreis_2WE_euro_kWh','jahresenergiekosten_2WE_euro_kWh'].includes(row) && value == 0){

                return '-'
            }
            if (['energieeffizienzklasse_endenergiebedarf'].includes(row)) return value;

            var precision = 0;
            if(['arbeitspreis_1WE_euro_kWh','arbeitspreis_2WE_euro_kWh','arbeitspreis_hilfsenergie_euro_kWh'].includes(row)) precision = 4
            if(['primaerenergetische_anlagenaufwandszahl'].includes(row)) precision = 2


            if(['spez_nutzenergiebedarf_kWh_m2_a','spez_primaerenergiebedarf_kWh_m2_a'].includes(row)) precision = 1


            return accounting.formatMoney(value, {
                symbol: '',
                format: '%v',
                precision: precision,
                decimal: ',',
                thousand: '.'
            }) + ' ' + unit;

        }

        const variantButtonClass = (direction, variantsCount) => {

            let buttonClass = '';

            switch (direction) {
                case 'prev':

                    if (activeVariant.value == '1') {
                        buttonClass = 'opacity-25 pointer-events-none'
                    }

                    break;
                case 'next':

                    if (resultData.variants) {
                        if ((resultData.variants.length - 1) == activeVariant.value) {
                            buttonClass = 'opacity-25 pointer-events-none'
                        }
                    }

                    break;
            }

            return buttonClass;
        }

        const changeVariant = (direction) => {

            switch (direction) {
                case 'prev':

                    if (activeVariant.value == '1') {

                        return false
                    }

                    activeVariant.value = activeVariant.value - 1

                    break;
                case 'next':

                    if (resultData.variants) {
                        if ((resultData.variants.length - 1) == activeVariant.value) {
                            return false
                        }
                    }

                    activeVariant.value = activeVariant.value + 1

                    break;
            }
            console.log('changeVariant', direction, resultData.variants.length)
        }

        const variantColClass = (variantIndex) => {

            return ['variant-index-' + variantIndex, variantIndex == 0 ? 'variant-reference' : 'variant-selection', variantIndex > 0 ? (activeVariant.value == variantIndex ? 'variant-active fade-in' : 'hidden') : '']
        }

        return {

            resultData,
            showGroupTd,
            getGroupRowspan,
            activeVariant,
            variantButtonClass,
            variantColClass,
            changeVariant,
            showVariantNavigation,
            activeSection,
            toggleTableContent,
            formatValue
        }
    }
}
</script>

<style scoped>

</style>
